// extracted by mini-css-extract-plugin
export default {"date-node":"styles-module__date-node__src-labstep-web-prosemirror-components-NodeView-Date-_YfKO8"};